import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {ChatPageToScreenProps, DrawState, FrameShapeProps, PageToScreenProps} from "../types/draw.types";
import {LoginProps, userState} from "../types/authority";

const initialState: userState = {
    useSuggestion: true,
    chatParameter: null,
    isClaimedDailyDrops: null,
    userInfo: null
};

export const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        setUseSuggestion: (state, action: PayloadAction<boolean>) => {
            state.useSuggestion = action.payload;
        },
        setChatParameter: (state, action: PayloadAction<string | null>) => {
            state.chatParameter = action.payload;
        },
        setIsClaimedDailyDrops: (state, action: PayloadAction<boolean | null>) => {
            state.isClaimedDailyDrops = action.payload;
        },
        setUserInfo: (state, action: PayloadAction<LoginProps | null>) => {
            state.userInfo = action.payload;
        }
    }
});

export const {
    setUseSuggestion,
    setChatParameter,
    setIsClaimedDailyDrops,
    setUserInfo
} = userSlice.actions;

export default userSlice.reducer;